export const GET_MASTERS_MENU = "get_masters_menu";
export const GET_MASTERS_MENU_SUCCESSFUL = "get_masters_menu_successful";
// export const ADD_MENU = "add_menu";
// export const PUT_MENU = "put_menu";
// export const DELETE_MENU = "delete_menu";

export const API_ERROR = "api_failed";
